
export enum BeaconOwnerTypeCd {
	CUSTOMER = 'Customer',
	LANE = 'Lane',
	LOAD = 'Load',
	SCHEDULE = 'Schedule',
	SHIPMENT = 'Shipment',
	TRAILER = 'Trailer',
	TRIP = 'Trip'}

